import { render } from "./AddTypeCargaisonPage.vue?vue&type=template&id=1dffaf2e&ts=true"
import script from "./AddTypeCargaisonPage.vue?vue&type=script&lang=ts"
export * from "./AddTypeCargaisonPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__